<template>
  <BaseButton v-if="!openForm" @click="openForm = true" theme="red" class="w-91">
    {{ $t('createLabel') }}
  </BaseButton>
  <TicketSystemAddForm v-else/>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import TicketSystemAddForm from "@/components/cabinet/Tickets/TicketsSystem/TicketsSystemAddForm";

export default {
  name: "TicketSystemAdd",
  data() {
    return {
      openForm: false
    }
  },
  components: {TicketSystemAddForm, BaseButton},
  i18n: {
    messages: {
      en: {
        createLabel: 'Write to us'
      },
      ru: {
        createLabel: 'Напишите нам'
      }
    }
  }
}
</script>